import { Extension } from '@tiptap/core'
import { Node } from '@tiptap/pm/model'
import { Plugin } from '@tiptap/pm/state'

type Dir = 'rtl' | 'ltr'

// RTL languages include (but are not limited to): Arabic, Hebrew, Persian (Farsi), Urdu, Syriac, Thaana (Maldivian), N'Ko, Mandaic, Samaritan, etc.
// This regex aims to match a broad set of RTL scripts used in Unicode.
const RTL_CHAR_REGEX =
  /[\u0590-\u05FF\u0600-\u06FF\u0700-\u08AC\u200F\uFB1D-\uFDFD\uFE70-\uFEFC\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0700-\u074F\u0780-\u07BF\u0840-\u085B\u0870-\u089F]/

const inferDirFromText = (text: string): Dir | null => {
  const trimmed = text.replace(/\s+/g, '')
  if (!trimmed) {
    return null
  }
  if (RTL_CHAR_REGEX.test(trimmed)) {
    return 'rtl'
  }
  return 'ltr'
}

const getFirstListItemText = (listNode: Node): string => {
  const first = listNode.firstChild
  return first?.textContent ?? ''
}

export const AutoListDirection = Extension.create({
  name: 'autoListDirection',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction: (transactions, _oldState, newState) => {
          const docChanged = transactions.some(tr => tr.docChanged)
          if (!docChanged) {
            return null
          }

          let tr = newState.tr
          let modified = false

          newState.doc.descendants((node, pos) => {
            if (
              node.type.name !== 'bulletList' &&
              node.type.name !== 'orderedList'
            ) {
              return
            }

            const dir = inferDirFromText(getFirstListItemText(node))
            if (!dir) {
              return
            }

            const currentDir = node.attrs?.dir as Dir | null | undefined
            if (currentDir === dir) {
              return
            }

            tr = tr.setNodeMarkup(pos, undefined, { ...node.attrs, dir })
            modified = true
          })

          return modified ? tr : null
        },
      }),
    ]
  },
})
